module.exports = __webpack_public_path__ + "img/page3.abc0241c.jpg";